'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

exports.default = function () {
  var detailNavSticky = new DetailNavSticky();

  if (!(0, _linksoftAlbatros.isMaxWidth)('md')) {
    detailNavSticky.init();
  }

  (0, _jquery2.default)('.product__rating', this).on('click', function () {
    _linksoftAlbatros.smoothScroll.animateScroll(document.querySelector('#productUserReviews'));
  });
};

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _linksoftAlbatros = require('linksoft-albatros');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_jquery2.default.fn.activeSection = function (options) {
  var opt = _jquery2.default.extend({
    link: 'a',
    offset: 150,
    sectionWrap: '.product__sections',
    callback: function callback() {}
  }, options);

  return (0, _jquery2.default)(this).each(function () {
    var $self = (0, _jquery2.default)(this),
        links = $self.find('li');

    function scrollToSection(e) {
      e.preventDefault();

      var scrollAnchor = (0, _jquery2.default)(this).attr('href');
      var anchor = document.querySelector(scrollAnchor);

      _linksoftAlbatros.smoothScroll.animateScroll(anchor, null, { "offset": opt.offset });
    }

    function setAtive() {
      (0, _jquery2.default)(opt.sectionWrap).find('[data-section]').each(function (i) {
        var windScroll = (0, _jquery2.default)(window).scrollTop(),
            $wrap = (0, _jquery2.default)(this),
            wrapOffsetTop = $wrap.offset().top,
            wrapHeight = $wrap.height(),
            wrapOffsetBot = wrapHeight + wrapOffsetTop,
            relativeTop = windScroll + opt.offset,
            isBetweenWrap = windScroll > wrapOffsetTop - opt.offset && windScroll < wrapOffsetBot;

        if ((0, _jquery2.default)(this).position().top <= relativeTop && isBetweenWrap) {

          links.removeClass('active');
          links.addClass('inactive');
          links.eq(i).removeClass('inactive').addClass('active');
        }
      });

      var firstSectiOffestTop = (0, _jquery2.default)((0, _jquery2.default)(opt.sectionWrap).find('[data-section]')[0]).position().top;
      if (firstSectiOffestTop > firstSectiOffestTop + opt.offset) {
        links.removeClass('inactive').removeClass('active');
      }
    }

    function init() {
      $self.on('click', opt.link, scrollToSection);
      (0, _jquery2.default)(window).on('scroll', _jquery2.default.throttle(200, setAtive));
    }

    init();
  });
};

var DetailNavSticky = function () {
  function DetailNavSticky() {
    (0, _classCallCheck3.default)(this, DetailNavSticky);

    this.$nav = (0, _jquery2.default)('.product__nav');
  }

  (0, _createClass3.default)(DetailNavSticky, [{
    key: 'init',
    value: function init() {
      var self = this;

      if (self.$nav.length === 0) return;

      self.$nav.stick_in_parent({
        offset_top: (0, _jquery2.default)('.header__bottom').height(),
        sticky_class: 'product__nav--stick',
        inner_scrolling: false
      }).on("sticky_kit:stick", function (e) {
        (0, _jquery2.default)('body').addClass('product-has-sticky');
      }).on("sticky_kit:unstick", function (e) {
        (0, _jquery2.default)('body').removeClass('product-has-sticky');
      });

      self.$nav.activeSection();
    }
  }]);
  return DetailNavSticky;
}();

;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/productDetailNav.js
// module id = 1079
// module chunks = 1